import { phoneAuthQueryKeys as e } from "./usePhoneAuthQueryKeys.mjs";
import { useQuery as t } from "@maat/store-hooks";
import { authApi as n } from "@maat/api-main";
//#region src/phone/useAuthCapabilitiesQuery.ts
var r = {
	phone_sign_in: !1,
	passkeys: !1
}, i = () => {
	let i = t({
		queryKey: e.capabilities(),
		queryFn: () => n.capabilities(),
		staleTime: 6e4,
		retry: !1,
		refetchOnWindowFocus: !1
	});
	return {
		...i,
		capabilities: i.data ?? r
	};
};
//#endregion
export { i as useAuthCapabilitiesQuery };
